import React from "react";
import { PageBody } from "../../../common/components/PageBody/PageBody";
import { DiscountCouponCard } from "../../../components/DiscountCouponCard/DiscountCouponCard";
import { MemberAccountSummaryCard } from "../../../components/MemberAccountSummaryCard/MemberAccountSummaryCard";
import { PageSection } from "../../../common/components/PageSection/PageSection";
import { MemberRewardCard } from "../../../components/MemberRewardCard/MemberRewardCard";
import { PageMessage } from "../../../common/components/PageMessage/PageMessage";
import { useZerezesClubAccount } from "../../../providers/ZerezesClubAccountProvider";

export const ZClubAccountPageBodyMemberAccount = () => {

  const [message, setMessage] = React.useState<string | null>(null);

  const {
    membershipLevelList,
    memberAccountGroupData,
    startExchangePointsReward
  } = useZerezesClubAccount();

  const renderLevelList = () => {
    const levelList = membershipLevelList.map((level, lindex) => {
      const nextLevel = membershipLevelList.length >= lindex + 1 ? membershipLevelList[lindex + 1] : null;
      return (
        <li key={`level-${level.id}`}>
          nível {level.id}: {level.pointsRequired}{nextLevel ? ` - ${(nextLevel.pointsRequired||0)-1}` : '...'}
        </li>
      )
    });

    return (
      <ul style={{marginBottom:'0'}}>
        {levelList}
      </ul>
    )
  }

  const renderAvailableCouponList = () => {
    const list: any[] = [];

    if (memberAccountGroupData?.cashbackDetails?.couponCode) {
      list.push(
        <DiscountCouponCard
          key={`cashback`}
          discountCoupon={{
            couponCode: memberAccountGroupData?.cashbackDetails?.couponCode,
            formattedCouponExpirationDate: memberAccountGroupData?.cashbackDetails?.formattedCashbackExpiresAt || '',
            discountValue: memberAccountGroupData?.cashbackDetails?.discountValue || 0,
          }}
          onCopy={(result) => {
            if (!result) {
              setMessage('Não foi possível copiar o cupom. Tente novamente e se o problema persistir fale com o time tech zrzs.');
              return;
            }
            setMessage(null)
          }}
        />
      );
    }

    const filteredPointsHistory = memberAccountGroupData?.pointsHistory.filter(cp =>
      !cp.couponCodeUsedAt && !cp.couponHasExpired && cp.couponCode);

    if (filteredPointsHistory && filteredPointsHistory.length > 0) {
      list.push(...filteredPointsHistory.map(transactionPoint => {
        return (
          <DiscountCouponCard
            key={`point-transaction-${transactionPoint.id}`}
            discountCoupon={transactionPoint}
            onCopy={(result) => {
              if (!result) {
                setMessage('Não foi possível copiar o cupom. Tente novamente e se o problema persistir fale com o time tech zrzs.');
                return;
              }
              setMessage(null)
            }}
          />
        )
      }));
    }

    return list.length > 0 ? list : <div>nenhum cupom disponível no momento</div>;
  }

  const renderMembershipLevelRewardList = () => {
    const list: any[] = [];

    if (memberAccountGroupData?.membershipLevelRewardList && memberAccountGroupData?.membershipLevelRewardList?.length > 0) {
      list.push(...memberAccountGroupData.membershipLevelRewardList.map(reward => {
        return (
          <MemberRewardCard
            key={`reward-${reward.id}`}
            memberAccount={memberAccountGroupData?.memberAccount}
            reward={reward}
            onExchange={startExchangePointsReward}
          />
        )
      }));
    }

    return list.length > 0 ? list : <div>nenhum cupom disponível no momento</div>;
  }

  return (
    <PageBody>
      {!memberAccountGroupData?.memberAccount ? (
        <PageMessage text={'Não tem como mostrar os dados do cliente agora. Tente novamente e se o problema persistir fale com o time tech zrzs.'} />
      ) : (
        <>

          {message ? <PageMessage text={message} /> : null}

          <MemberAccountSummaryCard
            memberAccount={memberAccountGroupData?.memberAccount}
            membershipLevel={membershipLevelList.find(level => level.id === memberAccountGroupData?.memberAccount?.membershipLevelId)}
          />

          <PageSection title={'níveis e faixa de pontos por nível'} marginTop={'1rem'}>
            {renderLevelList()}
          </PageSection>

          <PageSection title={'cashback e cupons de nível'} marginTop={'1rem'}>
            {renderAvailableCouponList()}
          </PageSection>

          <PageSection title={'cupons disponíveis para resgate'} marginTop={'1rem'}>
            {renderMembershipLevelRewardList()}
          </PageSection>

        </>
      )}
    </PageBody>
  );

}